<div
    sticky
    [stickyTop]="50"
    class="bazis-list bazis-list_step"
>
    @for (item of [].constructor(10); track $index) {
        <div class="bazis-item">
            <bazis-skeleton></bazis-skeleton>
        </div>
    }
</div>
